<template>
  <div class="el-page-header">
    <div class="el-page-header__left" @click="goback()" v-if="isback">
      <img
        width="16px"
        height="16px"
        :src="require('@/assets/images/dback.png')"
      />
      <div class="el-page-header__title" style="width: 32px; margin-left: 8px">
        返回
      </div>
    </div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in realBreadcrumbs"
        :key="index"
        :to="item.url ? { path: item.url } : ''"
      >
        {{ item.txt }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "breadcrumb",
  props: {
    isback: {
      type: Boolean,
      default: false
    },
    breadcrumbList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "user/getBreadCrumbs"
    }),
    realBreadcrumbs() {
      if (this.breadcrumbs && this.breadcrumbs.length) {
        if (this.breadcrumbList && this.breadcrumbList[2]) {
          return [...this.breadcrumbs, ...this.breadcrumbList.slice(2)];
        }
        return this.breadcrumbs;
      } else {
        return this.breadcrumbList;
      }
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.notCurrentPage {
}
/deep/.el-breadcrumb__inner.is-link {
  color: #606266;
  font-weight: 400;
}

/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 500 !important;
  color: #303133 !important;
}

.el-page-header {
  height: 24px;
  display: flex;
  align-items: center;
  &__left {
    display: flex;
    align-items: center;
  }
}
</style>
